module.exports = __webpack_public_path__ + "assets/img/7feb-tz.svg";